export const TELEGRAM_LINK = 'https://t.me/+JKJSZ5iSEdM4M2E1';
export const TWITTER_LINK = 'https://twitter.com/DegenPassiveInc';
export const FACEBOOK_LINK = 'https://www.facebook.com/ryan.jaenicke';
export const INSTAGRAM_LINK =
  'https://www.instagram.com/degeneratepassiveincome/';
export const TIKTOK_LINK = 'https://www.tiktok.com/@degeneratepassiveincome';
export const GET_STARTED_LINK = 'https://getstarted.bernardbonds.com/';
export const MOTHERSHIP_LINK = 'https://mothershipdefi.com/';
